import React from "react";
import type { FlashPayload } from "../../pages/MainAppPage/types";
import { useAppToast } from "./AppToastProvider";

type FlashToasterProps = {
  flash: FlashPayload;
};

/** Must match `require_login` alert in `application_controller.rb`. */
export const LOGIN_REQUIRED_FLASH_ALERT = "Please log in to continue.";

function flashAlertToast(alert: string): {
  title: string;
  tone: "default" | "error";
} {
  if (alert === LOGIN_REQUIRED_FLASH_ALERT) {
    return { title: "You've been signed out", tone: "default" };
  }
  return { title: "Something went wrong", tone: "error" };
}

const FlashToaster: React.FC<FlashToasterProps> = ({ flash }) => {
  const { pushToast } = useAppToast();

  React.useEffect(() => {
    if (flash.notice) {
      pushToast({
        title: "Success",
        description: flash.notice,
        tone: "success",
      });
    }

    if (flash.alert) {
      const { title, tone } = flashAlertToast(flash.alert);
      pushToast({
        title,
        description: flash.alert,
        tone,
      });
    }

    (flash.errors ?? []).forEach((error) => {
      pushToast({
        title: "Validation error",
        description: error,
        tone: "error",
      });
    });
  }, [flash.alert, flash.errors, flash.notice, pushToast]);

  return null;
};

export default FlashToaster;
